"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var apollo_cache_inmemory_1 = require("apollo-cache-inmemory");
var apollo_client_1 = require("apollo-client");
var apollo_link_1 = require("apollo-link");
var apollo_link_error_1 = require("apollo-link-error");
var apollo_link_http_1 = require("apollo-link-http");
var anyWindow = window;
var anyWindowURI = anyWindow && anyWindow.measuredApp && anyWindow.measuredApp.gqlURI;
var uri = anyWindowURI || "/apps/measured/graphql";
var apolloClient = new apollo_client_1.ApolloClient({
    connectToDevTools: true,
    link: apollo_link_1.ApolloLink.from([
        apollo_link_error_1.onError(function (_a) {
            var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError;
            if (graphQLErrors) {
                graphQLErrors.map(function (_a) {
                    var message = _a.message, locations = _a.locations, path = _a.path;
                    // TODO(jeffk): bug snag
                    return console.log("[GraphQL error]: Message: " + message + ", Location: " + locations + ", Path: " + path);
                });
            }
            if (networkError) {
                // TODO(jeffk): bug snag
                console.log("[Network error]: " + networkError);
            }
        }),
        new apollo_link_http_1.HttpLink({
            uri: uri,
            credentials: "same-origin",
        }),
    ]),
    cache: new apollo_cache_inmemory_1.InMemoryCache(),
    defaultOptions: {
        watchQuery: {
            fetchPolicy: "cache-first",
            errorPolicy: "ignore",
        },
        query: {
            fetchPolicy: "cache-first",
            errorPolicy: "all",
        },
        mutate: {
            errorPolicy: "all",
        },
    },
});
exports.default = apolloClient;
